import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn.js';
const variantClasses = {
    primary: 'bg-primary text-on-primary hover:opacity-90 active:opacity-80',
    secondary: 'bg-transparent text-foreground border border-border hover:bg-muted',
    destructive: 'bg-destructive text-on-primary hover:opacity-90 active:opacity-80',
    ghost: 'bg-transparent text-foreground hover:bg-muted',
};
const sizeClasses = {
    sm: 'px-3 min-h-[32px] text-sm',
    md: 'px-5 min-h-[40px] text-base',
    lg: 'px-6 min-h-[48px] text-md',
};
export const Button = React.forwardRef(({ className, variant = 'primary', size = 'md', loading, disabled, children, ...rest }, ref) => (_jsxs("button", { ref: ref, disabled: disabled || loading, className: cn('inline-flex items-center justify-center gap-2 rounded-sm font-semibold font-sans', 'transition-opacity duration-base', 'disabled:opacity-50 disabled:cursor-not-allowed', 'focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2', variantClasses[variant], sizeClasses[size], className), ...rest, children: [loading && _jsx(Loader2, { className: "animate-spin", size: 16, "aria-hidden": "true" }), children] })));
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map